export default (props, vars) => '';
